module.exports = __webpack_public_path__ + "img/Deep Scratches.7cd161fe.png";